import React, { useState, useEffect } from 'react';

const SplashScreen = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isAnimating, setIsAnimating] = useState(true);

  useEffect(() => {
    // Start fade out after 2 seconds
    const timer1 = setTimeout(() => {
      setIsAnimating(false);
    }, 2000);

    // Complete and unmount after 2.5 seconds
    const timer2 = setTimeout(() => {
      setIsVisible(false);
      onComplete();
    }, 2500);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 transition-opacity duration-500 ${
        isAnimating ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-20 w-96 h-96 bg-white/5 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 left-20 w-80 h-80 bg-blue-400/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '0.5s' }}></div>
      </div>

      {/* Logo Container */}
      <div className="relative z-10 flex flex-col items-center">
        {/* Animated Logo */}
        <div className="relative animate-bounce-slow">
          <div className="absolute -inset-4 bg-white/20 rounded-full blur-xl animate-pulse"></div>
          <img
            src="/logo-af.png"
            alt="Akademia Fitrah"
            className="relative w-32 h-32 object-contain drop-shadow-2xl"
          />
        </div>

        {/* Brand Name */}
        <div className="mt-8 text-center">
          <h1 className="font-bold text-white tracking-tight animate-fade-in text-center">
            <span className="text-2xl md:text-3xl block">Akademia</span>
            <span className="text-5xl md:text-6xl block mt-1">FITRAH</span>
          </h1>
          <p className="mt-3 text-blue-100 text-lg animate-fade-in-delayed">
            Pendidikan Berbasis Kesadaran
          </p>
        </div>

        {/* Loading Indicator */}
        <div className="mt-12 flex items-center gap-2">
          <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0s' }}></div>
          <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
        </div>
      </div>

      {/* Footer */}
      <div className="absolute bottom-8 text-center text-blue-200 text-sm">
        <p>Sadar &middot; Belajar &middot; Refleksi &middot; Dialog &middot; Bertumbuh</p>
      </div>
    </div>
  );
};

export default SplashScreen;
